import { DictContext } from "@/layout/context/DictContext";
import SText from "@/styles/SText";
import { WAddress } from "@/types/address";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider, Flex, Select, Tag, theme } from "antd";
import { DefaultOptionType } from "antd/es/select";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import AddressForm from "./AddressForm";
import { OptionsWraper } from "./style";

interface AddressSelectProps {
  currencys?: string;
  value?: string;
  onChange?: (address: string, addressData: WAddress | undefined) => void;
}


const AddressSelect: React.FC<AddressSelectProps> = ({ value, onChange }) => {
  const { addressData, setAddressData, currencys } = useContext(DictContext);
  const { token: { colorPrimary } } = theme.useToken();
  const { t } = useTranslation();
  const [addOpen, setAddOpen] = useState<boolean>(false);


  return (
    <>
      <Select onChange={val => onChange && onChange(val, addressData.find(a => a.address === val))} value={value}
        fieldNames={{ label: "address", value: "address" }}
        options={addressData} allowClear
        optionRender={info => (
          <Flex align="center" >
            <SText text={info.data.address} style={{ flex: 1 }} />
            <Tag color="green">{currencys.find(c => c.key === info.data.label1)?.desc}</Tag>
          </Flex>
        )}
        dropdownRender={menu => <>
          <>
            <OptionsWraper>{menu}</OptionsWraper>
            <Divider style={{ margin: "8px 0" }} />
            <Button
              type="text"
              style={{
                width: "100%",
                marginBottom: 4,
                color: colorPrimary,
              }}
              icon={<PlusOutlined />}
              onClick={() => setAddOpen(true)}
            >
              {t("common.add")}
            </Button>
          </>
        </>}
      />
      {addOpen && <AddressForm formType="ADD" onOk={res => {
        setAddressData([res, ...addressData]);
        setAddOpen(false)
      }} onCancel={() => setAddOpen(false)} />}
    </>
  )
};

export default AddressSelect;